import { Component } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { EnfermeraService } from 'src/app/services/enfermera.service';
import { HttpErrorResponse } from '@angular/common/http';
@Component({
  selector: 'app-enfermera',
  templateUrl: './enfermera.component.html',
  styleUrls: ['./enfermera.component.scss']
})
export class EnfermeraComponent {

  public totalCasosClinicos: number | undefined = 0;
  public totalProductos: number | undefined = 0;
  public totalPuntos: number | undefined = 0;
  public saldo: number | undefined = 0;

  constructor(public auth: AuthService, private enfermeraService: EnfermeraService) {
    if (this.auth.getUsuario?.enfermera?.id) {
      const idEnfermera = this.auth.getUsuario.enfermera.id;
      this.obtenerInformacion(idEnfermera);
    };

  }
  obtenerInformacion(id: number): void {
    this.enfermeraService.totales(id).subscribe({
      next: (resp) => {
        this.totalCasosClinicos = resp.datos.casosclinicos;
        this.totalProductos = resp.datos.productos;
        this.totalPuntos = resp.datos.puntos;
        this.saldo = resp.datos.saldo;
      },
      error: (err: HttpErrorResponse) => { console.log(err.error.message); }
    })
  }
  recargarInformacion(): void {
    if (this.auth.getUsuario?.enfermera?.id) {
      const idEnfermera = this.auth.getUsuario.enfermera.id;
      this.obtenerInformacion(idEnfermera);
    }
  }
}
